module.exports = __webpack_public_path__ + "static/media/Vonage.01c4ed4d.png";